import React, { useEffect, useState } from 'react';

const testimonialsData = [
    {
        name: 'Carlos M.',
        position: ' (El Salvador)',
        company: '.',
        text: 'Gracias a ustedes pude presentar mi caso de asilo y ahora tengo esperanza de un futuro mejor. Me explicaron todo con paciencia y claridad.',
        image: 'https://randomuser.me/api/portraits/men/32.jpg',
        rating: 5,
    },
    {
        name: 'Marisol T.',
        position: '(Honduras)',
        company: '.',
        text: 'Con la asesoría de ustedes logré traer a mi esposa e hijos a EE. UU. Siempre estuvieron atentos a cada detalle.',
        image: 'https://randomuser.me/api/portraits/women/45.jpg',
        rating: 5,
    },
    {
        name: 'Jairo Solís',
        position: '()',
        company: '.',
        text: 'Damos gracias a Dios primeramente y a usted estimada Paula junto a su equipo de trabajo tan profesional y especial. Ya hemos recibido nuestros permisos de trabajo, el de mi esposa, mi hijo y mío, gracias por toda la orientación tan especial en este proceso.',
        image: 'https://randomuser.me/api/portraits/women/45.jpg',
        rating: 5,
    },
    {
        name: 'Anayeli Montoya',
        position: '()',
        company: '.',
        text: 'Me llegó el permiso de trabajo, gracias a Dios y a todo el equipo por ayudarnos.',
        image: 'https://randomuser.me/api/portraits/women/45.jpg',
        rating: 5,
    },
    {
        name: 'Carlos Martinez',
        position: '()',
        company: '.',
        text: 'Ya llego mi social y el de mi hija, son los mejores, mil y mil gracias.',
        image: 'https://randomuser.me/api/portraits/women/45.jpg',
        rating: 5,
    },
    {
        name: 'Sergio Rozeck',
        position: '()',
        company: '.',
        text: 'Excelencia en la tarea que hacen, estamos infinitamente agradecidos. Asilo a tu alcance fue nuestra mejor elección, nuestro deseo es que mas personas cuenten con sus servicios.',
        image: 'https://randomuser.me/api/portraits/women/45.jpg',
        rating: 5,
    },
    {
        name: 'Rogelio Quintanilla',
        position: '()',
        company: '.',
        text: 'Gracias a Dios y a ustedes, siempre estuvieron atentos a cada detalle.',
        image: 'https://randomuser.me/api/portraits/women/45.jpg',
        rating: 5,
    },
    {
        name: 'Andrew Garcia',
        position: '()',
        company: '.',
        text: 'Ya me llegaron mis permisos de trabajo y mi social, gracias por todo, son muy profesionales.',
        image: 'https://randomuser.me/api/portraits/women/45.jpg',
        rating: 5,
    },
    {
        name: 'Mariana Méndez',
        position: '()',
        company: '.',
        text: 'Mil gracias de verdad por la ayuda tan oportuna de ustedes. Muchas bendiciones por lograr que los sueños se hagan realidad.',
        image: 'https://randomuser.me/api/portraits/women/45.jpg',
        rating: 5,
    },
    {
        name: 'Juan Felipe Rodríguez',
        position: '()',
        company: '.',
        text: 'Muchas gracias, no sabia lo de los referidos, me toma por sorpresa y realmente las referí porque me gusto mucho su trabajo y su atención. Espero seguir refiriendo para que sigan ayudando a más y más personas.',
        image: 'https://randomuser.me/api/portraits/women/45.jpg',
        rating: 5,
    },
    {
        name: 'Grecia Méndez',
        position: '()',
        company: '.',
        text: 'Muchisimas gracias, son los mejores de verdad. Gracias porque siempre nos orientaron y nos contestaron preguntas aún en la noche, ustedes estuvieron allí siempre para responderme. Gracias por este equipo tan increíble.',
        image: 'https://randomuser.me/api/portraits/women/45.jpg',
        rating: 5,
    },
];

const TestimoniosSlider = () => {
    const [index, setIndex] = useState(0);

    const next = () => setIndex((prev) => (prev + 1) % testimonialsData.length);
    const prev = () => setIndex((prev) => (prev - 1 + testimonialsData.length) % testimonialsData.length);

    const current = testimonialsData[index];

    useEffect(() => {
        const interval = setInterval(() => {
            next();
        }, 50000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="testimonial-slider">
            <div className="testimonial p-4 shadow active">
                {/* <img
                    src={current.image}
                    alt={current.name}
                    className="w-24 h-24 rounded-full object-cover mx-auto"
                /> */}
                <p className="parrafo text-secondary">
                    "{current.text}"
                </p>
                <h3>{current.name}</h3>
                <span className="position">{current.position}  <span className="company">{current.company}</span></span>
                <div className="stars">
                    {'★'.repeat(current.rating)}{'☆'.repeat(5 - current.rating)}
                </div>
            </div>

            <div className="navigation">
                <button id="prev" onClick={prev}>&#10094;</button>
                <button id="next" onClick={next}>&#10095;</button>
            </div>

            <div className="dots">
                {testimonialsData.map((_, i) => (
                    <span
                        key={i}
                        onClick={() => setIndex(i)}
                        className={`dot ${i === index ? 'active' : ''}`}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default TestimoniosSlider;